import axios from '@/plugins/axios'

const getComment = async id => {
  try {
    const response = await axios.get(`comments/${id}`)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getComments = async variables => {
  const { entityId, modelType, parentId, page } = variables
  const params = {}

  if (modelType === 'post' && entityId) params.post_id = entityId
  if (modelType === 'book' && entityId) params.book_id = entityId
  if (modelType) params.model_type = modelType
  if (parentId) params.parent_id = parentId
  params.page = page || 1

  try {
    const response = await axios.get('comments', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const createComment = async comment => {
  const form = {
    content: comment.content,
    model_type: comment.entityType,
    parent_id: comment.parentId
  }
  if (comment.entityType === 'post') {
    form.post_id = comment.entityId
  } else {
    form.book_id = comment.entityId
  }
  try {
    const response = await axios.post('comments', form)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const deleteComment = async id => {
  try {
    const response = await axios.post(`comments/${id}`, {
      _method: 'DELETE'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  getComment,
  getComments,
  createComment,
  deleteComment
}
